module.exports = __webpack_public_path__ + "img/neshan.762a02ab.png";